import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Static.css";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";

export const Cookies = () => {
  const GetScript = () => {
    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src =
      "https://consent.cookiebot.com/5d11cbe1-9b75-4c3f-b4f5-1085597a44d0/cd.js";
    script.type = "text/javascript";
    script.async = true;
    return script;
  };

  useEffect(() => {
    document.title = `Cookies | Staidium`;
  }, []);

  useEffect(() => {
    const scriptElement = GetScript();
    const targetElement = document.querySelector(".cookie-dec");
    if (targetElement) {
      targetElement.appendChild(scriptElement);
    }

    return () => {
      if (targetElement) {
        targetElement.removeChild(scriptElement);
      }
    };
  }, []);

  return (
    <>
      <Breadcrumb title="Cookie Settings" />
      <div className="static-page">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="cookie-dec" style={{ color: "#fff" }}></div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
